import { render, staticRenderFns } from "./points_task_polite.vue?vue&type=template&id=5bf1d170&scoped=true"
import script from "./points_task_polite.vue?vue&type=script&lang=js"
export * from "./points_task_polite.vue?vue&type=script&lang=js"
import style0 from "./points_task_polite.vue?vue&type=style&index=0&id=5bf1d170&prod&lang=scss&scoped=true"
import style1 from "./points_task_polite.vue?vue&type=style&index=1&id=5bf1d170&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf1d170",
  null
  
)

export default component.exports